import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const [err, setErr] = useState(null);
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { setErr("No session found. Please retry."); return; }
    const session_id = decodeURIComponent(match[1]);
    // Wipe fragment from URL immediately
    window.history.replaceState(null, "", window.location.pathname);

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        localStorage.setItem("sg_token", data.token);
        localStorage.setItem("sg_user", JSON.stringify(data.user));
        setUser(data.user);
        toast.success(`Welcome, ${data.user.name}`);
        nav("/guest", { replace: true });
      } catch (e) {
        setErr(e?.response?.data?.detail || "Google sign-in failed");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen grid place-items-center bg-background noise-bg" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-12 h-12 rounded-xl bg-primary text-primary-foreground grid place-items-center mx-auto animate-pulse">
          <Sparkles className="w-6 h-6" />
        </div>
        <div className="font-heading text-xl font-medium mt-4">
          {err ? "Sign-in failed" : "Finalizing your sign-in…"}
        </div>
        {err && (
          <div className="mt-3 text-sm text-destructive max-w-xs mx-auto">{err}</div>
        )}
        {err && (
          <button onClick={() => nav("/login", { replace: true })}
                  className="mt-5 text-primary underline text-sm" data-testid="auth-callback-retry">
            Back to login
          </button>
        )}
      </div>
    </div>
  );
}
